import dayjs, { Dayjs } from 'dayjs';

const PREGNANCY_TERM_WEEKS = 40;

/**
 * ПДР по текущей неделе беременности: сегодня + (40 - week) * 7 дней.
 * @see IOS_PROFILE_SPEC.md
 */
export function calculateDueDateFromWeek(week: number): Dayjs {
  const safeWeek = Math.max(1, Math.min(42, Math.round(week)));
  const weeksUntilDue = PREGNANCY_TERM_WEEKS - safeWeek;
  return dayjs().startOf('day').add(weeksUntilDue * 7, 'day');
}

/**
 * Текущая неделя по ПДР: 40 - (дней до ПДР / 7), в диапазоне 1–42.
 */
export function calculateWeekFromDueDate(dueDate: Dayjs | Date | string): number {
  const due = dayjs(dueDate).startOf('day');
  const today = dayjs().startOf('day');
  const daysUntilDue = due.diff(today, 'day');
  const weeksUntilDue = Math.round(daysUntilDue / 7);
  const currentWeek = PREGNANCY_TERM_WEEKS - weeksUntilDue;
  return Math.max(1, Math.min(42, currentWeek));
}
